import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex px-4" }
const _hoisted_2 = { class: "w-25 p-1" }
const _hoisted_3 = { class: "w-25 p-1" }
const _hoisted_4 = {
  class: "w-25 p-1",
  style: { minWidth: '100px' }
}

import { computed } from 'vue'
import { CoursePurchaseInvoice } from '../../../api/v2/models/course_purchase'
import { format } from 'date-fns'


export default /*@__PURE__*/_defineComponent({
  __name: 'CoursePurchaseInvoice',
  props: {
    coursePurchaseInvoice: {}
  },
  setup(__props: any) {

const props = __props

const date = computed(() => {
  return format(props.coursePurchaseInvoice.paiedAt, 'YYYY/MM/DD')
})

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(date.value), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.coursePurchaseInvoice.amountPaid.toLocaleString()) + "円", 1 /* TEXT */),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_chip, {
        class: "me-2 text-white",
        color: "blue",
        small: "",
        label: ""
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" 支払い済み ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}
}

})